
    import './styles.scoped.css';
    export default {
  "toggle": "awsui_toggle_1uo6m_1p106_97",
  "drawer-triggers": "awsui_drawer-triggers_1uo6m_1p106_103",
  "drawer": "awsui_drawer_1uo6m_1p106_103",
  "drawer-mobile": "awsui_drawer-mobile_1uo6m_1p106_113",
  "drawer-closed": "awsui_drawer-closed_1uo6m_1p106_116",
  "drawer-content": "awsui_drawer-content_1uo6m_1p106_123",
  "drawer-content-clickable": "awsui_drawer-content-clickable_1uo6m_1p106_135",
  "drawer-resize-content": "awsui_drawer-resize-content_1uo6m_1p106_145",
  "drawer-triggers-wrapper": "awsui_drawer-triggers-wrapper_1uo6m_1p106_151",
  "drawer-trigger": "awsui_drawer-trigger_1uo6m_1p106_103",
  "drawer-trigger-active": "awsui_drawer-trigger-active_1uo6m_1p106_170",
  "hide": "awsui_hide_1uo6m_1p106_178"
};
  